import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import util from '@utils/util';
import OneLink from '@utils/onelink';
import homeService from '@services/homeService';
import ReHeader from '../../../basic/re_header';
import ReFooter from '../../../basic/re_footer';
export default {
  name: 'indexmaterial',
  components: {
    'website-header': ReHeader,
    'website-footer': ReFooter
  },
  data: function data() {
    return {
      HomeAPIService: null,
      muted: true,
      newslist: [],
      showType: '',
      device: '',
      showDownload: null,
      downloads: {},
      newsPage: 0,
      pageSize: 8,
      IPCountryCode: ''
    };
  },
  computed: {
    newsTotalPage: function newsTotalPage() {
      return Math.ceil(this.newslist.length / this.pageSize);
    },
    newsCurrentPage: function newsCurrentPage() {
      return this.newsPage + 1;
    },
    newsListOfCurrentPage: function newsListOfCurrentPage() {
      var start = this.newsPage * this.pageSize;
      var end = start + this.pageSize;
      return this.newslist.slice(start, end);
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var globalParameter, showDownload, language, res, whiteList;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            util.handeError();
            globalParameter = util.getQueryData(window.location.search);
            _this.device = util.getBrand(window.navigator.userAgent);
            showDownload = false;
            language = window.navigator.language.toLowerCase();
            _context.next = 8;
            return util.getCountryCodeByIp();
          case 8:
            res = _context.sent.toLowerCase();
            _this.IPCountryCode = res.toUpperCase() || 'CN';
            if (res === 'cn') {
              whiteList = ['zh-hk', 'zh-tw', 'zh-mo'];
              if (whiteList.includes(language)) {
                showDownload = true;
              }
            } else {
              showDownload = true;
            }
            _this.showDownload = showDownload;
            _this.downloads = util.getDownloadURL(globalParameter.from, _this.device);
            _this.createOneLink();
            _context.next = 18;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 16]]);
    }))();
  },
  beforeMount: function beforeMount() {
    this.init();
    if (util.isMobile()) {
      this.showType = 'mobile';
    } else {
      this.showType = 'pc';
    }
  },
  mounted: function mounted() {
    if (this.showType == 'pc') {
      this.$refs.video.preload = 'auto';
      this.$refs.video.loop = true;
      this.$refs.video.muted = this.muted;
      this.$refs.video.setAttribute('playsinline', '');
      this.$refs.video.setAttribute('webkit-playsinline', '');
      this.$refs.video.autoplay = true;
      this.$refs.video.play();
    }
  },
  methods: {
    createOneLink: function createOneLink() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var queryValue, onelinkGenerator, oneLinkUrl;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // create onelink url for 推广 weboffice0518_
              queryValue = util.GetQueryString('from');
              if (queryValue && queryValue.indexOf('weboffice0518_') > -1) {
                onelinkGenerator = new OneLink({
                  oneLinkURL: 'https://guanwang.onelink.me/Boc2/',
                  pidKeysList: ['af_pid'],
                  pidStaticValue: encodeURIComponent('官网导量0518'),
                  campaignKeysList: ['af_c'],
                  campaignStaticValue: encodeURIComponent('官网')
                });
                onelinkGenerator.setChannel('original_url_channel', queryValue);
                oneLinkUrl = onelinkGenerator.generateUrl();
                console.info(_this2.downloads);
                _this2.downloads.applestore = oneLinkUrl;
                _this2.downloads.googleplay = oneLinkUrl;
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    init: function init() {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    } // try {
    //     this.newslist = (await this.getNewsList()).slice(0, 40);
    // } catch (e) {
    //     console.error('fetch news list failure:', e);
    // }
    ,
    getNewsList: function getNewsList() {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var HomeAPIService, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              HomeAPIService = homeService.createApi();
              _context4.next = 4;
              return HomeAPIService.getPCHomeNewsRevision('A_US');
            case 4:
              result = _context4.sent;
              return _context4.abrupt("return", Array.isArray(result) ? result.data : result.hot_news);
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 8]]);
      }))();
    },
    skipNewsPage: function skipNewsPage(page) {
      this.newsPage = page - 1;
    },
    getAndroidClass: function getAndroidClass() {
      if (this.device === 'apple' || this.device === 'huawei') {
        return 'android';
      } else {
        return this.device;
      }
    },
    anCroDown: function anCroDown() {
      window.location.href = this.downloads.android;
    },
    tongjiAppDown: function tongjiAppDown(name) {
      util.KEWLSensorTrack({
        lmweb_clickText: '首页下载app',
        lmweb_tabName: name
      });
    },
    toggleMuted: function toggleMuted() {
      this.muted = !this.muted;
    },
    getUrlLink: function getUrlLink(pathname) {
      var local = util.getI18nLocale();
      local = pathname == '/' ? '' : local;
      // 带参传递
      var json = {
        pathname: "/".concat(local).concat(pathname == '/' ? '' : pathname),
        search: {}
      };
      return util.directToPath(json, true);
    }
  }
};